import { getCurrentInstance, computed } from "vue";
import { useVuelidate } from "@vuelidate/core";

/**
 * Bridges legacy `$v` usage to Vuelidate 2's `v$`.
 * Components keep a `validations` option and call useVuelidate in setup via this mixin.
 */
export const vuelidateCompatMixin = {
  setup() {
    const instance = getCurrentInstance();
    const validations = instance?.type?.validations || instance?.proxy?.$options?.validations;
    if (!validations) {
      return {};
    }
    const v$ = useVuelidate();
    return { v$ };
  },
  computed: {
    $v() {
      return this.v$;
    }
  }
};

export default {
  install(app) {
    app.mixin(vuelidateCompatMixin);
  }
};
